import React from 'react';
import { Helmet } from 'react-helmet-async';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import CookiesContentFromMarkdown from '../Components/Cookies/CookiesContentFromMarkdown';
import $ from 'jquery';

export default function CookiesPolicy() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/Cookies-policy',
    title: 'Cookies policy',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20],
      filename: 'cookies-policy.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Cookies Policy</title>
        <meta name="description" content="" />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/Cookies-policy" />
        <meta property="og:title" content="DISGENET: Cookies Policy" />
        <meta
          property="og:description"
          content="This policy describes the cookies used by MedBioinformatics Solutions S.L (hereinafter, 'MedBio', the 'Company', or 'we/us')"
        />
      </Helmet>
      <CommonHeader />
      <section>
        <link rel="canonical" href="/Cookies-policy" />
        <div className="container txt-contenido mr-20 mt-2 text-right">
          <button
            className="btn bg-light rounded-circle fa fa-print"
            onClick={downloadSummary}
            title="Download PDF"
          ></button>
        </div>
        <div className="container txt-contenido" id="printer">
          <CookiesContentFromMarkdown />
        </div>
      </section>
    </React.Fragment>
  );
}
